import { Navigate } from 'react-router-dom'

// Settings page telah digabung ke /app-settings
// Redirect otomatis agar tidak ada link mati
export function SettingsPage() {
  return <Navigate to="/app-settings" replace />
}
